import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { Modal, Button } from 'react-bootstrap';
import { getTokenForAuthentication } from './Components/authentication/utils';

const UserStatusChecker = () => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const popupShownRef = useRef(false);
  const tokenRef = useRef(null);
  const intervalRef = useRef(null);

  const showPopupWithMessage = (message) => {
    setErrorMessage(message);
    setShowModal(true);
    popupShownRef.current = true;
  };

  const checkUserStatus = async (token) => {
    try {
      if (!sessionStorage.getItem('email')) return;

      const currentSession = await Auth.currentSession();
      const userEmail = sessionStorage.getItem('email') || '';
      const cognitoUserPool = process.env.REACT_APP_AGENT_USER_POOL || '';

      if (!userEmail || !cognitoUserPool || !currentSession) return;

      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}v1/csrportal/getuser`,
        {
          cognitoUserPool,
          username: userEmail
        },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            'x-tenant-id':
              'TkVUV0VMTDtUdWUgSmFuIDEzIDIwMjYgMTU6MjA6MTEgR01UKzA1MzAgKEluZGlhIFN0YW5kYXJkIFRpbWUp'
          }
        }
      );

      if (response.data?.errorCode) {
        setErrorMessage(response.data.message);
        setShowModal(true);
        return;
      }

      if (response.data?.enabled === false) {
        setErrorMessage(
          'Your user account has been disabled. Please contact administrator.'
        );
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        const message = String(error.response.data.message);

        if (message.toLowerCase().includes('not found')) {
          checkEmailChange(token);
        } else {
          setErrorMessage(message);
          setShowModal(true);
        }
      }
    }
  };

  const checkEmailChange = async (token) => {
    try {
      if (popupShownRef.current) return;

      const userData = JSON.parse(sessionStorage.getItem('USER_DATA') || '{}');
      const sessionEmail = sessionStorage.getItem('email');

      if (!userData.agentId || !sessionEmail) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/v1/agent/${userData.agentId}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          }
        }
      );

      const agentEmail = response?.data?.data?.email;

      if (
        agentEmail &&
        agentEmail.toLowerCase() !== sessionEmail.toLowerCase()
      ) {
        showPopupWithMessage(
          `Your email has been changed from ${sessionEmail} to ${agentEmail}. Please login again with your updated email.`
        );
      }
    } catch (error) {
      console.error('Error checking email change:', error);
    }
  };

  useEffect(() => {
    let isMounted = true;

    getTokenForAuthentication()
      .then((response) => {
        if (!isMounted) return;

        const token = response.headers.authorization;
        tokenRef.current = token;

        // Initial check
        checkUserStatus(token);

        // Poll every 10 seconds
        intervalRef.current = setInterval(() => {
          if (tokenRef.current) {
            checkUserStatus(tokenRef.current);
          }
        }, 300000);
      })
      .catch((error) => {
        console.error('Error getting authentication token:', error);
      });

    return () => {
      isMounted = false;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleLogout = async () => {
    try {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      await Auth.signOut();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    } catch (error) {
      console.error('Error during logout:', error);
      window.location.href = '/';
    }
  };

  return (
    <Modal show={showModal} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Session Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {errorMessage ||
            'Your session is no longer valid. Please log in again.'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ background: '#303192' }} onClick={handleLogout}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserStatusChecker;
